import { render, staticRenderFns } from "./NotificationEmitter.vue?vue&type=template&id=33b11550&"
import script from "./NotificationEmitter.vue?vue&type=script&lang=ts&"
export * from "./NotificationEmitter.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationEmitter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports